import React, { useMemo, useState } from "react";
import { PieChart, Pie, Sector } from "recharts";
import PropTypes from "prop-types";
import getStyled from "../../../hooks/getStyled";

const { theme } = getStyled();

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } =
    props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={innerRadius - 3}
        outerRadius={outerRadius + 3}
        fill={fill}
        style={{
          filter: "drop-shadow(2px 4px 6px #1356945C)",
        }}
      />
    </g>
  );
};

const SFPieChart = ({
  onMouseOver,
  onMouseLeave,
  data,
  colors = [
    theme.palette.blue500.main,
    theme.palette.blue300.main,
    theme.palette.blue200.main,
    theme.palette.blue100.main,
  ],
  dataKey = "value",
  width = 500,
  height = 500,
  legend1,
  legend2,
  barWidth = 15,
}) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const [filledData, setFilledData] = useState(data);

  useMemo(() => {
    setFilledData(data.map((a, i) => ({ ...a, fill: colors[i] })));
  }, [data]);

  return (
    <PieChart width={width} height={height}>
      <Pie
        activeIndex={activeIndex}
        activeShape={renderActiveShape}
        endAngle={450}
        startAngle={90}
        outerRadius={width / 2 - 20}
        innerRadius={width / 2 - 20 - barWidth}
        paddingAngle={0}
        dataKey={dataKey}
        data={filledData}
        onMouseEnter={(e, index) => {
          setActiveIndex(index);
          if (onMouseOver) onMouseOver(e.payload);
        }}
        onMouseLeave={() => {
          setActiveIndex(-1);
          onMouseLeave();
        }}
      />
      {legend1 && (
        <text
          x={width / 2}
          y={height / 2 - 10}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={20}
          fontFamily="EYInterstate"
          fill={theme.palette.grey450.main}
        >
          {legend1}
        </text>
      )}
      {legend2 && (
        <text
          x={width / 2}
          y={height / 2 + 10}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={12}
          fontFamily="EYInterstate"
          fill={theme.palette.grey400.main}
        >
          {legend2}
        </text>
      )}
    </PieChart>
  );
};

SFPieChart.propTypes = {
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  data: PropTypes.array.isRequired,
  colors: PropTypes.array,
  dataKey: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  barWidth: PropTypes.number,
  legend1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  legend2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SFPieChart;
